import React from 'react';
import FontTitle from '../../atoms/FontTitle';
import NewsList from '../../molecules/NewsList';
import InnerLink from '../../atoms/InnerLink';
import { MoreButton } from '../../atoms/Button';
import Anchor from '../../atoms/Anchor';
// CSSはインポートした順に生成され、後にインポートしたCSSの方が優先されるので、
// まず他のコンポーネントや共通CSSをインポートして、その後でコンポーネントごとのCSSをインストールすること
// つまり、styles.module.cssのインポートはインポート文の複数行のうちの最後に置いておくのが安全
import styles from './styles.module.css';

export type NewsAreaProps = {
};


const NewsArea : React.FC<NewsAreaProps> = () => {
    return (
        <div className={ styles['news-area'] }>
            <div className={styles['news-title-box']}>
                <div className={styles['news-title-inner']}>
                    <h2 className={styles['news-title']}><FontTitle>メモアカからの</FontTitle><FontTitle>お知らせ</FontTitle></h2>
                    <div className={styles['text-center']}><InnerLink to='/news'><MoreButton>一覧へ</MoreButton></InnerLink></div>
                </div>
            </div>

            <div className={styles['news-body']}>
                <div className={styles['news-wrap']}>
                  <NewsList date='2025.07.02'>7/1 0:11〜7/2 21:15にかけて、有料会員向けコンテンツを正常に見ることができない不具合が発生いたしました。現在は解消済みです。ご迷惑をおかけしまして申し訳ありません。</NewsList>
                </div>
                <div className={styles['news-wrap']}>
                  <NewsList date='2025.07.01'>「今月のチャレンジ 星座記憶」コースを追加しました!</NewsList>
                </div>
                <div className={styles['news-wrap']}>
                  <NewsList date='2025.06.02'>「今月のチャレンジ 西洋絵画記憶」コースを追加しました!</NewsList>
                </div>
                <div className={styles['news-wrap']}>
                  <NewsList date='2025.05.01'>「今月のチャレンジ 国旗国名記憶 アジア・オセアニア編」コースを追加しました!</NewsList>
                </div>
                <div className={styles['news-wrap']}>
                  <NewsList date='2025.04.01'>「今月のチャレンジ 名字ランキング」コースを追加しました!</NewsList>
                </div>
            </div>
        </div>
    );
};

export default NewsArea;
